<template>
  <div class="panel-option">
    <div v-if="!Array.isArray(element)" class="item-title">
      <b-badge class="m-1 text-overflow-ellipsis" variant="dark">
        {{ element.name }}
      </b-badge>
      <b-badge class="m-1 text-overflow-ellipsis" variant="secondary">
        {{ element.type }}
      </b-badge>
    </div>
    <div v-else class="item-title">
      <b-badge
        v-for="el in selectedElements"
        :key="el.name"
        class="m-1 text-overflow-ellipsis"
        variant="secondary"
        >{{ el.name }}</b-badge
      ><br /><b-badge
        v-for="el in elementTypes"
        :key="el.name"
        class="m-1 text-overflow-ellipsis"
        variant="secondary"
        >{{ el.name }}</b-badge
      >
    </div>
    <div class="item-title">
      <p v-if="assocFilters.length > 0">
        - Associated with:
        <strong v-if="assocFilters.length === 0">No Filters</strong>
      </p>
      <b-badge
        v-for="a in assocFilters"
        :key="a._id"
        variant="dark"
        class="m-1 text-overflow-ellipsis hover"
        @click="filterDetail(a)"
        >{{ a.name }}</b-badge
      >
    </div>
    <div class="options d-flex justify-content-start ml-auto mr-2">
      <!--<b-btn variant="creax" @click="addToFocus()" class="ml-2" v-if="element.type !== 'Document'"><i class="fa fa-bullseye"></i> New Focus</b-btn>-->
      <b-btn
        v-if="element.type !== 'Document'"
        variant="outline-secondary"
        size="sm"
        class="ml-2"
        @click="addToFocus()"
        ><i class="fa fa-bullseye"></i> Focus</b-btn
      >
      <b-btn
        v-if="element.type !== 'Document'"
        variant="outline-secondary"
        size="sm"
        class="ml-2"
        @click="addToFilter('new')"
        ><i class="fa fa-filter"></i> New Filter</b-btn
      >
      <b-btn
        v-if="element.type !== 'Document'"
        variant="outline-secondary"
        size="sm"
        class="ml-2"
        @click="addToFilter('current')"
        ><i class="fa fa-plus"></i> Add to Filter</b-btn
      >
      <b-button-group>
        <b-btn
          v-if="element.type !== 'Document'"
          variant="outline-secondary"
          size="sm"
          class="ml-2"
          @click="filterDocs(element)"
          ><i class="fa fa-filter"></i> Filter Documents</b-btn
        >
        <b-btn
          v-if="element.type !== 'Document'"
          variant="outline-secondary"
          size="sm"
          @click="clearFilter()"
          ><i class="fa fa-eraser"></i
        ></b-btn>
      </b-button-group>
    </div>
    <b-btn variant="outline-secondary" size="sm" @click="closeOptionsPanel()"
      ><i class="fa fa-times"></i
    ></b-btn>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters, mapState } from "vuex";
import { EventBus } from "@/eventBus";
import { filterOutIdName, prepFilter, parseSelectedElements } from "../../../helpers/PrepFilters";
export default {
  name: "PanelOptions",
  props: {
    element: {
      required: true
    }
  },
  data() {
    return {
      assocFilters: [],
      selectedElements: [],
      selectedElementsObjects: [],
      elementTypes: []
    };
  },
  computed: {
    ...mapGetters(["ttcLookup"]),
    ...mapState({
      filterFocused: state => state.filter.filterFocused,
      filters: state => state.filter.filters,
      subsetFilter: state => state.filter.subsetFilter,
      filterSidebarState: state => state.layout.filterSidebarState
    })
  },
  watch: {
    element(newVal) {
      this.getSelectedElements(newVal);
      this.getAssociatedFilters(newVal);
      this.loadActiveElement({ element: newVal });
      //this.filterDocs(newVal);
    }
  },
  mounted() {
    this.getSelectedElements(this.element);
    this.loadActiveElement({ element: this.element });
    this.getAssociatedFilters(this.element);
    //this.filterDocs(this.element);
    //EventBus.$on('showDoc', (doc) => {
    //  this.viewDoc(doc);
    //});
  },
  methods: {
    ...mapActions([
      "filterFocus",
      "saveSubsetFilter",
      "loadActiveElement",
      "saveFilterElement",
      "saveFilterQuery",
      "saveFilterSidebarState"
    ]),
    getSelectedElements(elements) {
      if (!Array.isArray(elements)) {
        // TODO: Always send "elements" as an array?
        elements = [[elements]];
      }
      this.selectedElements = [];
      this.elementTypes = [];
      this.selectedElementsObjects = [];
      let eltypes = new Set();
      elements.forEach(element => {
        let objs = [];
        element.forEach(el => {
          objs.push(el);
          eltypes.add(el.type);
        });
        this.selectedElements.push({
          name: objs.map(x => x.name).join(" AND ")
        });
        this.selectedElementsObjects.push(objs);
      });

      this.elementTypes = [...eltypes].map(x => {
        return { name: x };
      });

      // elements.forEach(element => {
      //   this.selectedElements.push({_id: element._id, name: element.name });
      //   if(_.find(this.elementTypes, { name: element.type }) === undefined){
      //     this.elementTypes.push({_id: element._id, name: element.type});
      //   }
      // });
      // if(this.elementTypes.length > 1){
      //   let temp = [];
      //   let group = {};
      //   let reset = false;
      //   this.selectedElements.forEach(element => {
      //     if(!reset){
      //       group._id = element._id;
      //       group.name = element.name;
      //       reset = true;
      //     }
      //     else{
      //       group.name += ' AND '+element.name;
      //       reset = false;
      //       temp.push(group);
      //       group = {};
      //     }
      //   });
      //   this.selectedElements = temp;
      // }
    },
    closeOptionsPanel() {
      this.loadActiveElement({ element: null });
      this.saveFilterElement({ element: null });
      EventBus.$emit("showOptions", null);
      //this.$emit('updateDocPanel');
    },
    getAssociatedFilters(el) {
      let associatedFilters = [];
      if (!Array.isArray(el)) {
        // Only check if a single item is selected
        _.forEach(this.filters, function(category) {
          _.forEach(category.children, function(subcat) {
            _.forEach(subcat.children, function(filter) {
              let json = JSON.stringify(filter.rawquery);
              if (json.includes('{"_id":"' + el.id + '"')) {
                associatedFilters.push(filter);
              }
            });
          });
        });
      }
      this.assocFilters = [...new Set(associatedFilters)];
    },
    filterDetail(filter) {
      if(!this.filterSidebarState){
        this.saveFilterSidebarState(!this.filterSidebarState);
      }
      EventBus.$emit("editFilter", filter);
    },
    addToFilter(selection) {
      if(!this.filterSidebarState){
        this.saveFilterSidebarState(!this.filterSidebarState);
      }
      
      let item = this.element;

      if (this.element.type === "Theme" && !this.element.children) {
        // Needed to get concepts
        item = this.ttcLookup({ id: this.element._id });
      }
      let { filt } = parseSelectedElements(item);
      this.saveFilterElement({ element: filt, type: selection });
    },
    filterDocs(element) {
      let { filt } = parseSelectedElements(element);
      let selection = prepFilter(filt, this.filterFocused);
      this.saveFilterQuery({ query: selection });
    },
    clearFilter() {
      this.loadActiveElement({ element: null });
      this.saveFilterElement({ element: null });
      this.saveFilterQuery({ query: [] });
    },
    viewDocs() {
      EventBus.$emit("showDocumentsPanel");
    },
    viewDoc(docid) {
      EventBus.$emit("showDocumentsPanel");
      setTimeout(() => {
        EventBus.$emit("viewDocument", docid);
      }, 500);
    },
    
    addToFocus() {
      let { filt, name } = parseSelectedElements(this.element);
      let filterToApply = {
        name: name,
        rawquery: [filterOutIdName(filt)]
      };
      this.filterFocus({ filter: filterToApply, type: "focus" }).then(() => {
        if (this.$route.name !== "ExploreDiscover") {
          this.$router.push({ name: "ExploreDiscover" });
        }
      });
    }
  }
};
</script>
